/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
import React, { useRef, useEffect, useState, useContext } from "react";
// import useWebSocket from "react-use-websocket";
import { Link } from "react-router-dom";
import { Tab, Nav, Modal } from "react-bootstrap";
import loadable from "@loadable/component";
import pMinDelay from "p-min-delay";

import { ThemeContext } from "../../../context/ThemeContext";

// import Index5CoinChart from "./Index5/Index5CoinChart";
// import OrderTab from "../Trading/Future/OrderTab";
import TradeTab from "../Trading/Future/TradeTab";

// import RangeSlider from "../bootstrap/RangeSlider";
import { SocketContext } from "../../../context/WebSocketContext";
// import modal from "../../../images/illustration/modal.png";
// import Toastr from "../PluginsMenu/Toastr/Toastr";
import { toast } from "react-toastify";
import GaugeChart from "../bootstrap/GuageChart";
import CountdownToNextMinute from "../bootstrap/CountDown";
import TradingViewWidget from "../bootstrap/TradingViewWidget";
import AccountBalanceChart from "./AccountBalanceChart";

const WidgetChartIndex3 = loadable(() =>
  pMinDelay(import("./Index3/WidgetChartIndex3"), 1000)
);

const tabHeading = [
  {
    title: "Default",
    keytype: "default",
    changelog: "default",
    svg: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 9.50011C15.9993 8.67201 15.328 8.00092 14.5001 8H10V11H14.5001C15.328 10.9993 15.9993 10.328 16 9.50011Z"
          fill="#FFAB2D"
        />
        <path
          d="M10 16H14.5001C15.3285 16 16 15.3285 16 14.5001C16 13.6715 15.3285 13 14.5001 13H10V16Z"
          fill="#FFAB2D"
        />
        <path
          d="M12 0C5.3726 0 0 5.3726 0 12C0 18.6274 5.3726 24 12 24C18.6274 24 24 18.6274 24 12C23.9924 5.37574 18.6243 0.00758581 12 0ZM18.0001 14.5713C17.9978 16.4641 16.4641 17.9978 14.5716 17.9999V18.8571C14.5716 19.3305 14.1876 19.7143 13.7144 19.7143C13.2409 19.7143 12.8572 19.3305 12.8572 18.8571V17.9999H11.1431V18.8571C11.1431 19.3305 10.7591 19.7143 10.2859 19.7143C9.8124 19.7143 9.42866 19.3305 9.42866 18.8571V17.9999H6.85733C6.38387 17.9999 6.00013 17.6161 6.00013 17.1429C6.00013 16.6695 6.38387 16.2857 6.85733 16.2857H7.71427V7.71427H6.85733C6.38387 7.71427 6.00013 7.33053 6.00013 6.85707C6.00013 6.38361 6.38387 5.99987 6.85733 5.99987H9.42866V5.14293C9.42866 4.66947 9.8124 4.28573 10.2859 4.28573C10.7593 4.28573 11.1431 4.66947 11.1431 5.14293V5.99987H12.8572V5.14293C12.8572 4.66947 13.2409 4.28573 13.7144 4.28573C14.1879 4.28573 14.5716 4.66947 14.5716 5.14293V5.99987C16.4571 5.99202 17.992 7.5139 18.0001 9.39937C18.0043 10.3978 17.5714 11.3481 16.8152 12C17.5643 12.6445 17.9967 13.5828 18.0001 14.5713Z"
          fill="#FFAB2D"
        />
      </svg>
    ),
  },
  {
    title: "Bitcoin",
    keytype: "btc",
    changelog: "bitcoin ms-0",
    svg: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 9.50011C15.9993 8.67201 15.328 8.00092 14.5001 8H10V11H14.5001C15.328 10.9993 15.9993 10.328 16 9.50011Z"
          fill="#FFAB2D"
        />
        <path
          d="M10 16H14.5001C15.3285 16 16 15.3285 16 14.5001C16 13.6715 15.3285 13 14.5001 13H10V16Z"
          fill="#FFAB2D"
        />
        <path
          d="M12 0C5.3726 0 0 5.3726 0 12C0 18.6274 5.3726 24 12 24C18.6274 24 24 18.6274 24 12C23.9924 5.37574 18.6243 0.00758581 12 0ZM18.0001 14.5713C17.9978 16.4641 16.4641 17.9978 14.5716 17.9999V18.8571C14.5716 19.3305 14.1876 19.7143 13.7144 19.7143C13.2409 19.7143 12.8572 19.3305 12.8572 18.8571V17.9999H11.1431V18.8571C11.1431 19.3305 10.7591 19.7143 10.2859 19.7143C9.8124 19.7143 9.42866 19.3305 9.42866 18.8571V17.9999H6.85733C6.38387 17.9999 6.00013 17.6161 6.00013 17.1429C6.00013 16.6695 6.38387 16.2857 6.85733 16.2857H7.71427V7.71427H6.85733C6.38387 7.71427 6.00013 7.33053 6.00013 6.85707C6.00013 6.38361 6.38387 5.99987 6.85733 5.99987H9.42866V5.14293C9.42866 4.66947 9.8124 4.28573 10.2859 4.28573C10.7593 4.28573 11.1431 4.66947 11.1431 5.14293V5.99987H12.8572V5.14293C12.8572 4.66947 13.2409 4.28573 13.7144 4.28573C14.1879 4.28573 14.5716 4.66947 14.5716 5.14293V5.99987C16.4571 5.99202 17.992 7.5139 18.0001 9.39937C18.0043 10.3978 17.5714 11.3481 16.8152 12C17.5643 12.6445 17.9967 13.5828 18.0001 14.5713Z"
          fill="#FFAB2D"
        />
      </svg>
    ),
  },
  {
    title: "Ethereum",
    keytype: "eth",
    changelog: "etherum",
    svg: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.3801 13.8734C12.136 13.9546 11.864 13.9546 11.6199 13.8734L9 13L12 18L15 13L12.3801 13.8734Z"
          fill="#00ADA3"
        />
        <path d="M12 12L15 10.8001L12 6L9 10.8001L12 12Z" fill="#00ADA3" />
        <path
          d="M12 0C5.3726 0 0 5.3726 0 12C0 18.6274 5.3726 24 12 24C18.6274 24 24 18.6274 24 12C23.9927 5.37574 18.6243 0.00732425 12 0ZM17.0524 11.5263L12.7667 20.0977C12.5551 20.5212 12.04 20.6928 11.6168 20.4812C11.4507 20.3983 11.3162 20.2638 11.2333 20.0977L6.94757 11.5263C6.81443 11.2589 6.8296 10.9416 6.9876 10.6882L11.2733 3.83111C11.5582 3.42984 12.114 3.33515 12.5153 3.62001C12.5972 3.67808 12.6686 3.74923 12.7267 3.83111L17.0121 10.6882C17.1704 10.9416 17.1856 11.2589 17.0524 11.5263Z"
          fill="#00ADA3"
        />
      </svg>
    ),
  },
  {
    title: "Dodge",
    keytype: "doge",
    changelog: "doge",
    svg: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 0C5.3726 0 0 5.3726 0 12C0 18.6274 5.3726 24 12 24C18.6274 24 24 18.6274 24 12C23.9927 5.37574 18.6243 0.00732425 12 0V0ZM7.04462 11.1428H10.4732C10.9466 11.1428 11.3304 11.5265 11.3304 12C11.3304 12.4735 10.9466 12.8572 10.4732 12.8572H7.04462C6.57116 12.8572 6.18742 12.4735 6.18742 12C6.18742 11.5265 6.57142 11.1428 7.04462 11.1428ZM17.7624 9.92331L16.7315 15.0812C16.4887 16.2784 15.4374 17.1401 14.2158 17.1429H7.04462C6.57116 17.1429 6.18742 16.7592 6.18742 16.2857C6.18742 15.8123 6.57142 15.4285 7.04462 15.4285H14.2158C14.621 15.4275 14.9697 15.1418 15.0503 14.7448L16.0814 9.58692C16.173 9.12654 15.8743 8.67924 15.4141 8.58768C15.3595 8.57696 15.304 8.57147 15.2486 8.57147H8.75902C8.28556 8.57147 7.90182 8.18773 7.90182 7.71427C7.90182 7.24081 8.28556 6.85707 8.75902 6.85707H15.2486C16.6648 6.85759 17.8123 8.00567 17.8121 9.42186C17.8121 9.59006 17.7953 9.75799 17.7624 9.92331V9.92331Z"
          fill="#3693FF"
        />
      </svg>
    ),
  },
  {
    title: "BNB",
    keytype: "bnb",
    changelog: "bnb",
    svg: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 0C5.3726 0 0 5.3726 0 12C0 18.6274 5.3726 24 12 24C18.6274 24 24 18.6274 24 12C23.9927 5.37574 18.6243 0.00732425 12 0V0ZM7.04462 11.1428H10.4732C10.9466 11.1428 11.3304 11.5265 11.3304 12C11.3304 12.4735 10.9466 12.8572 10.4732 12.8572H7.04462C6.57116 12.8572 6.18742 12.4735 6.18742 12C6.18742 11.5265 6.57142 11.1428 7.04462 11.1428ZM17.7624 9.92331L16.7315 15.0812C16.4887 16.2784 15.4374 17.1401 14.2158 17.1429H7.04462C6.57116 17.1429 6.18742 16.7592 6.18742 16.2857C6.18742 15.8123 6.57142 15.4285 7.04462 15.4285H14.2158C14.621 15.4275 14.9697 15.1418 15.0503 14.7448L16.0814 9.58692C16.173 9.12654 15.8743 8.67924 15.4141 8.58768C15.3595 8.57696 15.304 8.57147 15.2486 8.57147H8.75902C8.28556 8.57147 7.90182 8.18773 7.90182 7.71427C7.90182 7.24081 8.28556 6.85707 8.75902 6.85707H15.2486C16.6648 6.85759 17.8123 8.00567 17.8121 9.42186C17.8121 9.59006 17.7953 9.75799 17.7624 9.92331V9.92331Z"
          fill="#3693FF"
        />
      </svg>
    ),
  },
  {
    title: "Cardano",
    keytype: "ada",
    changelog: "ada",
    svg: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 0C5.3726 0 0 5.3726 0 12C0 18.6274 5.3726 24 12 24C18.6274 24 24 18.6274 24 12C23.9927 5.37574 18.6243 0.00732425 12 0V0ZM7.04462 11.1428H10.4732C10.9466 11.1428 11.3304 11.5265 11.3304 12C11.3304 12.4735 10.9466 12.8572 10.4732 12.8572H7.04462C6.57116 12.8572 6.18742 12.4735 6.18742 12C6.18742 11.5265 6.57142 11.1428 7.04462 11.1428ZM17.7624 9.92331L16.7315 15.0812C16.4887 16.2784 15.4374 17.1401 14.2158 17.1429H7.04462C6.57116 17.1429 6.18742 16.7592 6.18742 16.2857C6.18742 15.8123 6.57142 15.4285 7.04462 15.4285H14.2158C14.621 15.4275 14.9697 15.1418 15.0503 14.7448L16.0814 9.58692C16.173 9.12654 15.8743 8.67924 15.4141 8.58768C15.3595 8.57696 15.304 8.57147 15.2486 8.57147H8.75902C8.28556 8.57147 7.90182 8.18773 7.90182 7.71427C7.90182 7.24081 8.28556 6.85707 8.75902 6.85707H15.2486C16.6648 6.85759 17.8123 8.00567 17.8121 9.42186C17.8121 9.59006 17.7953 9.75799 17.7624 9.92331V9.92331Z"
          fill="#3693FF"
        />
      </svg>
    ),
  },
  {
    title: "Pepe",
    keytype: "pepe",
    changelog: "pepe",
    svg: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 0C5.3726 0 0 5.3726 0 12C0 18.6274 5.3726 24 12 24C18.6274 24 24 18.6274 24 12C23.9927 5.37574 18.6243 0.00732425 12 0V0ZM7.04462 11.1428H10.4732C10.9466 11.1428 11.3304 11.5265 11.3304 12C11.3304 12.4735 10.9466 12.8572 10.4732 12.8572H7.04462C6.57116 12.8572 6.18742 12.4735 6.18742 12C6.18742 11.5265 6.57142 11.1428 7.04462 11.1428ZM17.7624 9.92331L16.7315 15.0812C16.4887 16.2784 15.4374 17.1401 14.2158 17.1429H7.04462C6.57116 17.1429 6.18742 16.7592 6.18742 16.2857C6.18742 15.8123 6.57142 15.4285 7.04462 15.4285H14.2158C14.621 15.4275 14.9697 15.1418 15.0503 14.7448L16.0814 9.58692C16.173 9.12654 15.8743 8.67924 15.4141 8.58768C15.3595 8.57696 15.304 8.57147 15.2486 8.57147H8.75902C8.28556 8.57147 7.90182 8.18773 7.90182 7.71427C7.90182 7.24081 8.28556 6.85707 8.75902 6.85707H15.2486C16.6648 6.85759 17.8123 8.00567 17.8121 9.42186C17.8121 9.59006 17.7953 9.75799 17.7624 9.92331V9.92331Z"
          fill="#3693FF"
        />
      </svg>
    ),
  },
  {
    title: "Solana",
    keytype: "sol",
    changelog: "sol",
    svg: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 0C5.3726 0 0 5.3726 0 12C0 18.6274 5.3726 24 12 24C18.6274 24 24 18.6274 24 12C23.9927 5.37574 18.6243 0.00732425 12 0V0ZM7.04462 11.1428H10.4732C10.9466 11.1428 11.3304 11.5265 11.3304 12C11.3304 12.4735 10.9466 12.8572 10.4732 12.8572H7.04462C6.57116 12.8572 6.18742 12.4735 6.18742 12C6.18742 11.5265 6.57142 11.1428 7.04462 11.1428ZM17.7624 9.92331L16.7315 15.0812C16.4887 16.2784 15.4374 17.1401 14.2158 17.1429H7.04462C6.57116 17.1429 6.18742 16.7592 6.18742 16.2857C6.18742 15.8123 6.57142 15.4285 7.04462 15.4285H14.2158C14.621 15.4275 14.9697 15.1418 15.0503 14.7448L16.0814 9.58692C16.173 9.12654 15.8743 8.67924 15.4141 8.58768C15.3595 8.57696 15.304 8.57147 15.2486 8.57147H8.75902C8.28556 8.57147 7.90182 8.18773 7.90182 7.71427C7.90182 7.24081 8.28556 6.85707 8.75902 6.85707H15.2486C16.6648 6.85759 17.8123 8.00567 17.8121 9.42186C17.8121 9.59006 17.7953 9.75799 17.7624 9.92331V9.92331Z"
          fill="#3693FF"
        />
      </svg>
    ),
  },
  {
    title: "XRP",
    keytype: "xrp",
    changelog: "xrp",
    svg: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 0C5.3726 0 0 5.3726 0 12C0 18.6274 5.3726 24 12 24C18.6274 24 24 18.6274 24 12C23.9927 5.37574 18.6243 0.00732425 12 0V0ZM7.04462 11.1428H10.4732C10.9466 11.1428 11.3304 11.5265 11.3304 12C11.3304 12.4735 10.9466 12.8572 10.4732 12.8572H7.04462C6.57116 12.8572 6.18742 12.4735 6.18742 12C6.18742 11.5265 6.57142 11.1428 7.04462 11.1428ZM17.7624 9.92331L16.7315 15.0812C16.4887 16.2784 15.4374 17.1401 14.2158 17.1429H7.04462C6.57116 17.1429 6.18742 16.7592 6.18742 16.2857C6.18742 15.8123 6.57142 15.4285 7.04462 15.4285H14.2158C14.621 15.4275 14.9697 15.1418 15.0503 14.7448L16.0814 9.58692C16.173 9.12654 15.8743 8.67924 15.4141 8.58768C15.3595 8.57696 15.304 8.57147 15.2486 8.57147H8.75902C8.28556 8.57147 7.90182 8.18773 7.90182 7.71427C7.90182 7.24081 8.28556 6.85707 8.75902 6.85707H15.2486C16.6648 6.85759 17.8123 8.00567 17.8121 9.42186C17.8121 9.59006 17.7953 9.75799 17.7624 9.92331V9.92331Z"
          fill="#3693FF"
        />
      </svg>
    ),
  },
];

const Home = () => {
  const socket = useContext(SocketContext);
  // const navigate = useNavigate();

  const symbol = "BTCUSDT";
  // const streamUrl = `wss://stream.binance.com:9443/ws/${symbol.toLowerCase()}@trade`;

  const { changeBackground } = useContext(ThemeContext);

  const [selectedCoin, setSelectedCoin] = useState(() => {
    // Get stored selected coin from localStorage
    const storedCoin = localStorage.getItem("selectedCoin");

    // Get parsed data from localStorage
    const storedData = localStorage.getItem("plowdata");
    const parsed = storedData ? JSON.parse(storedData) : null;

    // If there's a stored coin and it exists in parsed data, use it
    if (storedCoin && parsed && parsed[storedCoin.toLowerCase()]) {
      return storedCoin;
    }

    // Otherwise, if parsed data exists, use the first key
    if (parsed && Object.keys(parsed).length > 0) {
      return Object.keys(parsed)[0];
    }

    // Fallback to the default from tabHeading
    return tabHeading[0].keytype;
  });

  const [data, setData] = useState(
    document.querySelectorAll("#status_wrapper tbody tr")
  );

  const [tabeData, setTabeData] = useState(() => {
    // Initialize state from local storage if available
    const savedData = localStorage.getItem("plowdata");

    if (savedData) {
      const parsed = JSON.parse(savedData);

      const {
        CurrentPrice,
        LongEntryPrice = 0,
        LongPositionSize = 0,
        ShortEntryPrice = 0,
        ShortPositionSize = 0,
        LongTakeProfit = 0,
        ShortTakeProfit = 0,
        ShortDrawdownStop = 0,
        LongDrawdownStop = 0,
        LongPnl,
        ShortPnl,
        LongDate,
        ShortDate,
      } = parsed;

      let a = [];

      if (parsed.LongPositionSize > 0) {
        a.push({
          pair: "BTCUSD",
          side: "Long",
          size: LongPositionSize.toString(),
          price: `$${CurrentPrice}`,
          entry: `$${LongEntryPrice}`,
          status: "open",
          pnl: LongPnl,
          date: LongDate,
          rPnl: LongTakeProfit,
          sPnl: LongDrawdownStop,
        });
      } else if (parsed.ShortPositionSize < 0) {
        a.push({
          pair: "BTCUSD",
          side: "Short",
          size: ShortPositionSize.toString(),
          price: `$${CurrentPrice}`,
          entry: `$${ShortEntryPrice}`,
          status: "open",
          pnl: ShortPnl,
          date: ShortDate,
          rPnl: ShortTakeProfit,
          sPnl: ShortDrawdownStop,
        });
      } else {
      }

      return a;
    } else {
      return [];
    }
  });

  const [activityData, setActivityData] = useState(() => {
    const savedData = localStorage.getItem("activityData");
    return savedData ? JSON.parse(savedData) : [];
  });

  const [aiTradeData, setAiTradeData] = useState(() => {
    const storedData = localStorage.getItem("plowdata");

    const coinToUse = selectCoinToUse(selectedCoin);
    console.log("coint", selectedCoin, coinToUse);

    if (storedData) {
      const parsed = JSON.parse(storedData);
      console.log("first", parsed);
      console.log("second", parsed[coinToUse]);
      return [
        {
          id: 1,
          name: "Account Balance",
          price: `$${Number(parsed[coinToUse].accountBalance).toFixed(2)}`,
          bgcolor: "bg-warning",
          data: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            Number(parsed[coinToUse].accountBalance).toFixed(2) / 1000,
          ],
        },
        {
          id: 2,
          name: "Current Price",
          price: `$${Number(parsed[coinToUse].currentPrice).toFixed(2)}`,
          bgcolor: "bg-pink",
          data: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            Number(parsed[coinToUse].currentPrice).toFixed(2) / 1000,
          ],
        },
      ];
    } else {
      return [
        {
          id: 1,
          name: "Account Balance",
          price: "$0",
          bgcolor: "bg-warning",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
        {
          id: 2,
          name: "Current Price",
          price: "$0",
          bgcolor: "bg-pink",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
      ];
    }
  });

  const [winAndLossData, setWinAndLossData] = useState([
    {
      id: 1,
      name: "Wins",
      price: "$0",
      bgcolor: "bg-success",
      data: [],
      xAxisData: [], // Dates
    },
    {
      id: 2,
      name: "Losses",
      price: "$0",
      bgcolor: "bg-danger",
      data: [],
      xAxisData: [], // Dates
    },
  ]);

  // y-axis formart = [Open, High, Low, Close]
  const [barchartData, setBarchartData] = useState({
    pair: "BTC/USDT",
    data: [],
  });

  const [test, settest] = useState(0);

  const [prediction, setPrediction] = useState(() => {
    // Initialize state from local storage if available
    const savedData = localStorage.getItem("plowdata");

    if (savedData) {
      const parsed = JSON.parse(savedData);

      return parsed.prediction;
    } else {
      return 0.5;
    }
  });

  const [showImageModal, setShowImageModal] = useState(false);

  const [modalImageSrc, setModalImageSrc] = useState("");

  // Add this state variable
  const [accountBalanceData, setAccountBalanceData] = useState([]);

  // const { lastJsonMessage } = useWebSocket(streamUrl, {
  //   onOpen: () => console.log("Connected to the stream!"),
  //   onClose: () => console.log("Disconnected from the stream!"),
  //   shouldReconnect: (closeEvent) => true, // Will attempt to reconnect on all disconnects
  // });

  function selectCoinToUse(selectedCoin) {
    let coinToUse = "btc";
    if (selectedCoin != "default") coinToUse = selectedCoin;
    return coinToUse;
  }

  const updateAccountBalance = (data) => {
    const { AccountBalance: newBalance, CurrentPrice, LongEntryPrice } = data;

    setAiTradeData((prevData) => {
      const updatedData = prevData.map((item) => {
        let newPrice;
        let balanceValue;

        if (item.id === 1) {
          newPrice = `$${parseFloat(newBalance).toFixed(2)}`;
          balanceValue = parseFloat(newBalance) / 1000;
        } else if (item.id === 2) {
          newPrice = `$${parseFloat(CurrentPrice).toFixed(2)}`;
          balanceValue = parseFloat(CurrentPrice) / 1000;
        } else if (item.id === 3) {
          newPrice = `$${parseFloat(LongEntryPrice).toFixed(2)}`;
          balanceValue = parseFloat(LongEntryPrice) / 1000;
        } else {
          return item;
        }

        const newData = [...item.data, balanceValue];

        if (newData.length > 100) {
          newData.shift(); // Remove the oldest element if array length exceeds 10
        }

        return { ...item, price: newPrice, data: newData };
      });

      // Update local storage
      // localStorage.setItem("plowdata", JSON.stringify(updatedData));

      return updatedData;
    });
  };

  const updateCurrentPrice = (data) => {
    setAiTradeData((prevData) => {
      const updatedData = prevData.map((item) => {
        let newPrice;
        let balanceValue;

        if (item.id === 2) {
          newPrice = `$${parseFloat(data).toFixed(2)}`;
          balanceValue = parseFloat(data) / 1000;
        } else {
          return item;
        }

        const newData = [...item.data, balanceValue];

        if (newData.length > 100) {
          newData.shift(); // Remove the oldest element if array length exceeds 10
        }

        return { ...item, price: newPrice, data: newData };
      });

      return updatedData;
    });
  };

  // const handleShowImageModal = (imageSrc) => {
  //   setModalImageSrc(imageSrc);
  //   setShowImageModal(true);
  // };

  // Function to convert the historical data into the desired format
  // const formatHistoricalData = (data) => {
  //   return data.map((item) => ({
  //     x: new Date(item[0]),
  //     y: [
  //       parseFloat(item[1]),
  //       parseFloat(item[2]),
  //       parseFloat(item[3]),
  //       parseFloat(item[4]),
  //     ],
  //   }));
  // };

  // const processTradeData = (trade) => {
  //   setBarchartData((currentData) => {
  //     const newTradeTime = new Date(trade.E);
  //     const newTradePrice = parseFloat(trade.p);
  //     let lastEntry = currentData.data[currentData.data.length - 1];
  //     let updatedData;
  //     if (
  //       !lastEntry ||
  //       new Date(lastEntry.x).getMinutes() !== newTradeTime.getMinutes()
  //     ) {
  //       // Start a new minute entry
  //       updatedData = {
  //         ...currentData,
  //         data: [
  //           ...currentData.data,
  //           {
  //             x: new Date(newTradeTime.setSeconds(0, 0)),
  //             y: [newTradePrice, newTradePrice, newTradePrice, newTradePrice],
  //           },
  //         ],
  //       };
  //     } else {
  //       // Update the last entry
  //       lastEntry.y = [
  //         lastEntry.y[0], // Open remains the same
  //         Math.max(lastEntry.y[1], newTradePrice), // High
  //         Math.min(lastEntry.y[2], newTradePrice), // Low
  //         newTradePrice, // Close is the latest price
  //       ];
  //       updatedData = currentData;
  //     }

  //     // Ensure that the length of updatedData does not exceed 200 elements
  //     if (updatedData.length > 250) {
  //       return updatedData.slice(updatedData.length - 250);
  //     }

  //     return updatedData;
  //   });
  // };

  const handleCoinSelect = (coinKeytype) => {
    setSelectedCoin(coinKeytype);
    localStorage.setItem("selectedCoin", coinKeytype);
    window.location.reload(); // Refreshes the page to load new data
  };

  // Function to convert coin keytype to TradingView symbol format
  const getTradingViewSymbol = (coinKey) => {
    const coinToUse = selectCoinToUse(selectedCoin);
    return `BINANCE:${coinToUse.toUpperCase()}USDT`;
  };

  // use effects

  // this makes sure we use the dark theme
  useEffect(() => {
    changeBackground({ value: "dark", label: "Dark" });

    // Handle metrics (long positions)
    socket.on("metrics", (data) => {
      localStorage.setItem("plowdata", JSON.stringify(data));
      updateMetrics(data, "Long");
    });

    // Handle metrics_short (short positions)
    socket.on("metrics_short", (data) => {
      localStorage.setItem("plowdata_short", JSON.stringify(data));
      updateMetrics(data, "Short");
    });

    // Shared function to handle both long and short updates
    const updateMetrics = (data, side) => {
      // Initialize an array to hold new position data for this side
      const newPositionData = [];
      let totalAccountBalance = 0;

      // Process each token in the data
      Object.values(data).forEach((tokenData) => {
        const {
          coin,
          accountBalance,
          currentPrice,
          positionAmount,
          averageEntryPrice,
          pnl,
          prediction,
          volume,
        } = tokenData;

        // Accumulate account balance (assuming it's the same for all tokens)
        totalAccountBalance = parseFloat(accountBalance);

        const coinToUse = selectCoinToUse(selectedCoin);

        // For BTC specifically, you might want to keep your existing behavior
        if (coin.toLowerCase() == coinToUse) {
          setPrediction(prediction);
          updateAccountBalance({
            AccountBalance: accountBalance,
            LongEntryPrice: averageEntryPrice,
            CurrentPrice: currentPrice,
          });
        }

        // Update account balance chart data
        setAccountBalanceData((prevData) => {
          const newData = [
            {
              timestamp: new Date().toISOString(),
              accountBalance: Number(accountBalance),
            },
            ...prevData,
          ];
          if (newData.length > 500) {
            newData.pop();
          }
          return newData;
        });

        // Create position data for each token
        if (positionAmount > 0) {
          newPositionData.push({
            pair: `${coin}USD`,
            side: side, // Use the provided side (Long/Short)
            size: positionAmount.toString(),
            price: `$${currentPrice}`,
            entry: `$${averageEntryPrice}`,
            status: "open",
            pnl: pnl,
            date: new Date().toISOString(),
            rPnl: 0,
            sPnl: 0,
          });
        }
      });

      // Update the table data - preserve positions of the opposite side
      setTabeData((prevData) => {
        // Filter out existing positions of this side
        const filteredData = prevData.filter(
          (position) => position.side !== side
        );
        // Add the new positions for this side
        return [...filteredData, ...newPositionData];
      });
    };

    socket.on("update", (data) => {
      // console.log("update", data);
      const [pred, current, coin, { value }] = data;

      const coinToUse = selectCoinToUse(selectedCoin);

      if (selectedCoin == "default") {
        setPrediction(pred);
        if (coinToUse.toUpperCase() == coin) {
          updateCurrentPrice(current);
        }
      } else {
        if (coinToUse.toUpperCase() == coin) {
          updateCurrentPrice(current);
          setPrediction(pred);
        }
      }

      if (coinToUse.toUpperCase() == coin) {
        updateCurrentPrice(current);
        setPrediction(pred);
      }
    });

    socket.on("activity", (data) => {
      toast.success(`${data[0]} - ${data[1]} - $${data[2]}`, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      // Update the activities state
      setActivityData((prevActivities) => {
        const newActivity = {
          message: data[0],
          quantity: data[1],
          currentPrice: data[2],
          date: data[3] || new Date(),
          realizedPnl: data[4] || 0,
          image: data[5] || "",
        };

        const updatedActivities = [newActivity, ...prevActivities].sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );

        if (updatedActivities.length > 2000) {
          updatedActivities.length = 2000;
        }

        localStorage.setItem("activityData", JSON.stringify(updatedActivities));
        return updatedActivities;
      });
    });

    // Listen for the 'last100Activities' event
    socket.on("last100Activities", (data) => {
      const sortedData = data.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );

      localStorage.setItem("activityData", JSON.stringify(sortedData));
      setActivityData(sortedData);
    });

    return () => {
      socket.off("metrics");
      socket.off("update");
      socket.off("last100Activities");
      socket.off("activity");
    };
  }, []);

  // this useEffect get historical data for the chart before it is being updated by the web hook
  useEffect(() => {
    // Fetch historical data
    const fetchHistoricalData = async () => {
      try {
        // const interval = "1m"; // 1-minute intervals
        // const limit = 2000; // Number of minutes in 24 hours

        // const url = `https://api.binance.com/api/v3/klines?symbol=${symbol}&interval=${interval}&limit=${limit}`;
        const url = `http://35.205.213.3:4005/historical`;

        const response = await fetch(url);

        const data = await response.json();

        // setBarchartData({ pair: "BTC/USDT", data: formatHistoricalData(data) });
      } catch (error) {
        console.error("Error fetching historical data:", error);
      }
    };

    // fetchHistoricalData();
  }, [symbol]);

  // Fetch initial data for account balance
  useEffect(() => {
    const fetchAccountBalanceHistory = async () => {
      try {
        const response = await fetch(
          "https://api.plowgpt.com/api/accountBalanceHistory"
        );
        const data = await response.json();
        setAccountBalanceData(data.data);
      } catch (error) {
        console.error("Error fetching account balance history:", error);
      }
    };
    fetchAccountBalanceHistory();
  }, []);

  useEffect(() => {
    const fetchWinsLossesData = async () => {
      try {
        const response = await fetch(
          "https://api.plowgpt.com/api/winsLossesData"
        );
        const { data } = await response.json();
        setWinAndLossData((prevData) =>
          prevData.map((item) => {
            if (item.id === 1) {
              return {
                ...item,
                data: data.wins.map((entry) => entry.realizedPnl),
                price: `$${data.wins
                  .reduce((sum, entry) => sum + entry.realizedPnl, 0)
                  .toFixed(2)}`,
                xAxisData: data.wins.map((entry) =>
                  new Date(entry.date).toLocaleDateString()
                ),
              };
            } else if (item.id === 2) {
              return {
                ...item,
                data: data.losses.map((entry) => entry.realizedPnl),
                price: `$${data.losses
                  .reduce((sum, entry) => sum + entry.realizedPnl, 0)
                  .toFixed(2)}`,
                xAxisData: data.losses.map((entry) =>
                  new Date(entry.date).toLocaleDateString()
                ),
              };
            } else {
              return item;
            }
          })
        );
      } catch (error) {
        console.error("Error fetching wins/losses data:", error);
      }
    };
    fetchWinsLossesData();
  }, []);

  // Update on socket events
  useEffect(() => {
    socket.on("activity_tp", (data) => {
      const [
        message,
        quantity,
        currentPrice,
        realizedPnl,
        activityDate,
        ,
        ,
        ,
        image,
      ] = data;
      setWinAndLossData((prevData) =>
        prevData.map((item) => {
          if (item.id === 1) {
            const newData = [...item.data, realizedPnl];
            return {
              ...item,
              data: newData,
              price: `$${newData
                .reduce((sum, val) => sum + val, 0)
                .toFixed(2)}`,
            };
          }
          return item;
        })
      );

      // Update the activities state
      setActivityData((prevActivities) => {
        const newActivity = {
          message,
          quantity,
          currentPrice,
          date: activityDate || new Date(), // assuming new activity is added with current timestamp
          realizedPnl,
          image,
        };

        // Add the new activity to the beginning of the array and sort by createdAt
        const updatedActivities = [newActivity, ...prevActivities].sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );

        // Limit the array to the last 2000 activities
        if (updatedActivities.length > 2000) {
          updatedActivities.length = 2000;
        }

        localStorage.setItem("activityData", JSON.stringify(updatedActivities));

        return updatedActivities;
      });
    });

    socket.on("activity_sl", (data) => {
      const [
        message,
        quantity,
        currentPrice,
        realizedPnl,
        activityDate,
        ,
        ,
        ,
        image,
      ] = data;
      setWinAndLossData((prevData) =>
        prevData.map((item) => {
          if (item.id === 2) {
            const newData = [...item.data, realizedPnl];
            return {
              ...item,
              data: newData,
              price: `$${newData
                .reduce((sum, val) => sum + val, 0)
                .toFixed(2)}`,
            };
          }
          return item;
        })
      );

      // Update the activities state
      setActivityData((prevActivities) => {
        const newActivity = {
          message,
          quantity,
          currentPrice,
          date: activityDate || new Date(), // assuming new activity is added with current timestamp
          realizedPnl,
          image,
        };

        // Add the new activity to the beginning of the array and sort by createdAt
        const updatedActivities = [newActivity, ...prevActivities].sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );

        // Limit the array to the last 2000 activities
        if (updatedActivities.length > 2000) {
          updatedActivities.length = 2000;
        }

        localStorage.setItem("activityData", JSON.stringify(updatedActivities));

        return updatedActivities;
      });
    });

    return () => {
      socket.off("activity_tp");
      socket.off("activity_sl");
    };
  }, []);

  // used for pagination
  useEffect(() => {
    setData(document.querySelectorAll("#status_wrapper tbody tr"));
    //chackboxFun();
  }, [test]);

  // used for websocket messages from useWebSocket
  // useEffect(() => {
  //   if (lastJsonMessage) {
  //     console.log("lastJsonMessage", lastJsonMessage);
  //     processTradeData(lastJsonMessage);
  //   }
  // }, [lastJsonMessage]);

  // pagination logic
  const sort = 50;
  const activePag = useRef(0);

  // Active data
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };

  // Active pagginarion
  activePag.current === 0 && chageData(0, sort);
  // paggination
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);

  // Active paggination & chage data
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
    settest(i);
  };

  return (
    <>
      <div className="row">
        <div className="col-xl-12">
          {/* colored bars on top */}
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body pt-3 pb-3">
                <div className="coin-warpper d-flex align-items-center justify-content-between flex-wrap">
                  <div>
                    <Nav as="ul" className=" nav-pills">
                      {tabHeading.map((item, index) => (
                        <Nav.Item as="li" key={index}>
                          <Nav.Link
                            as="button"
                            className={`${item.changelog}`}
                            eventKey={item.keytype}
                            active={selectedCoin === item.keytype}
                            onClick={() => handleCoinSelect(item.keytype)}
                          >
                            {item.svg}
                            {item.title}
                          </Nav.Link>
                        </Nav.Item>
                      ))}
                    </Nav>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            {aiTradeData.map((item, ind) => (
              <div className="col-xl-6 col-lg-6 col-sm-6" key={ind}>
                <div className={`card card-box ${item.bgcolor}`}>
                  <div className="card-header border-0 pb-0">
                    <div className="chart-num-days">
                      <p>{item.name}</p>
                      <h2 className="count-num text-white">{item.price}</h2>
                    </div>
                    {item.id === 1 ? (
                      <svg
                        width="50"
                        height="50"
                        viewBox="0 0 137 137"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M92.9644 53.8221C92.9599 48.4197 88.5804 44.0417 83.1795 44.0357H53.822V63.6069H83.1795C88.5804 63.6024 92.9599 59.2229 92.9644 53.8221Z"
                          fill="#FFF"
                        />
                        <path
                          d="M53.822 92.9645H83.1795C88.5834 92.9645 92.9644 88.5835 92.9644 83.1796C92.9644 77.7743 88.5834 73.3933 83.1795 73.3933H53.822V92.9645Z"
                          fill="#FFF"
                        />
                        <path
                          d="M68.5001 9.15527e-05C30.6687 9.15527e-05 0.00012207 30.6687 0.00012207 68.5001C0.00012207 106.332 30.6687 137 68.5001 137C106.332 137 137 106.332 137 68.5001C136.957 30.6866 106.314 0.0433939 68.5001 9.15527e-05V9.15527e-05ZM102.751 83.1781C102.737 93.9828 93.9829 102.737 83.1797 102.749V107.643C83.1797 110.345 80.9877 112.536 78.2865 112.536C75.5838 112.536 73.3933 110.345 73.3933 107.643V102.749H63.6084V107.643C63.6084 110.345 61.4164 112.536 58.7153 112.536C56.0126 112.536 53.8221 110.345 53.8221 107.643V102.749H39.144C36.4414 102.749 34.2509 100.559 34.2509 97.8577C34.2509 95.155 36.4414 92.9645 39.144 92.9645H44.0357V44.0357H39.144C36.4414 44.0357 34.2509 41.8452 34.2509 39.1425C34.2509 36.4399 36.4414 34.2493 39.144 34.2493H53.8221V29.3577C53.8221 26.655 56.0126 24.4645 58.7153 24.4645C61.4179 24.4645 63.6084 26.655 63.6084 29.3577V34.2493H73.3933V29.3577C73.3933 26.655 75.5838 24.4645 78.2865 24.4645C80.9891 24.4645 83.1797 26.655 83.1797 29.3577V34.2493C93.9426 34.2045 102.705 42.8919 102.751 53.6548C102.775 59.3543 100.304 64.7791 95.9867 68.5001C100.263 72.1793 102.731 77.5354 102.751 83.1781V83.1781Z"
                          fill="#FFF"
                        />
                      </svg>
                    ) : item.id === 2 ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50px"
                        height="50px"
                      >
                        <path
                          fillRule="evenodd"
                          fill="rgb(255, 255, 255)"
                          d="M21.000,42.000 C9.402,42.000 -0.001,32.598 -0.001,21.000 C-0.001,9.402 9.402,-0.000 21.000,-0.000 C32.592,0.013 41.987,9.408 42.000,21.000 C42.000,32.598 32.598,42.000 21.000,42.000 ZM28.171,14.437 C28.383,14.172 28.499,13.843 28.499,13.504 C28.500,12.675 27.829,12.001 26.999,12.000 L22.499,12.000 L22.499,7.500 C22.499,6.672 21.828,6.000 21.000,6.000 C20.171,6.000 19.500,6.671 19.500,7.500 L19.500,12.000 L15.000,12.000 C14.171,12.000 13.499,12.671 13.499,13.500 C13.499,14.328 14.171,15.000 15.000,15.000 L23.878,15.000 L13.827,27.562 C13.615,27.829 13.499,28.160 13.499,28.501 C13.499,29.329 14.171,30.000 15.000,30.000 L19.500,30.000 L19.500,34.500 C19.500,35.328 20.171,36.000 21.000,36.000 C21.828,36.000 22.499,35.328 22.499,34.500 L22.499,30.000 L26.999,30.000 C27.828,30.000 28.500,29.328 28.500,28.500 C28.500,27.672 27.828,27.000 26.999,27.000 L18.121,27.000 L28.171,14.437 Z"
                        />
                      </svg>
                    ) : item.id === 3 ? (
                      <svg
                        width="50"
                        height="50"
                        viewBox="0 0 137 137"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M70.3615 78.5206C69.1671 78.9977 67.8366 78.9977 66.6421 78.5206L53.8232 73.3927L68.5018 102.75L83.1804 73.3927L70.3615 78.5206Z"
                          fill="#FFF"
                        />
                        <path
                          d="M68.4982 68.5L88.0696 61.6503L68.4982 34.25L48.9268 61.6503L68.4982 68.5Z"
                          fill="#FFF"
                        />
                        <path
                          d="M68.5 0C30.6686 0 0 30.6686 0 68.5C0 106.331 30.6686 137 68.5 137C106.331 137 137 106.331 137 68.5C136.958 30.6865 106.313 0.0418093 68.5 0V0ZM97.3409 65.7958L72.8765 114.725C71.6685 117.142 68.7285 118.122 66.3125 116.914C65.3643 116.44 64.5968 115.673 64.1235 114.725L39.6591 65.7958C38.899 64.2698 38.9856 62.4586 39.8875 61.0117L64.3519 21.8692C65.978 19.5787 69.151 19.0381 71.4416 20.6642C71.9089 20.9957 72.3166 21.4019 72.6481 21.8692L97.111 61.0117C98.0144 62.4586 98.101 64.2698 97.3409 65.7958V65.7958Z"
                          fill="#FFF"
                        />
                      </svg>
                    ) : item.id === 4 ? (
                      <svg
                        width="50"
                        height="45"
                        viewBox="0 0 137 137"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M68.5 0C30.6686 0 0 30.6686 0 68.5C0 106.331 30.6686 137 68.5 137C106.331 137 137 106.331 137 68.5C136.958 30.6865 106.313 0.0418093 68.5 0ZM40.213 63.6068H59.7843C62.4869 63.6068 64.6774 65.7973 64.6774 68.5C64.6774 71.2027 62.4869 73.3932 59.7843 73.3932H40.213C37.5104 73.3932 35.3199 71.2027 35.3199 68.5C35.3199 65.7973 37.5119 63.6068 40.213 63.6068ZM101.393 56.6456L95.5088 86.0883C94.1231 92.9226 88.122 97.8411 81.1488 97.8576H40.213C37.5104 97.8576 35.3199 95.6671 35.3199 92.9644C35.3199 90.2617 37.5119 88.0712 40.213 88.0712H81.1488C83.4617 88.0652 85.4522 86.4347 85.9121 84.168L91.7982 54.7253C92.3208 52.0973 90.6156 49.544 87.9891 49.0214C87.677 48.9601 87.3605 48.9288 87.0439 48.9288H49.9994C47.2967 48.9288 45.1062 46.7383 45.1062 44.0356C45.1062 41.3329 47.2967 39.1424 49.9994 39.1424H87.0439C95.128 39.1454 101.679 45.699 101.677 53.7831C101.677 54.7433 101.582 55.7019 101.393 56.6456Z"
                          fill="#FFF"
                        ></path>
                      </svg>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="card-body p-0 custome-tooltip">
                    {/* <div id="widgetChart3" className="chart-primary"></div> */}
                    <WidgetChartIndex3 title={item.name} data={item.data} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="col-xl-12">
          <div className="row main-card">
            {/* bar chart */}
            <div className="col-xxl-12 col-lg-12">
              <div className="row">
                <div className="col-xxl-7 col-xl-7">
                  <div style={{ height: "472px" }} className="card">
                    <div style={{ display: "none" }} className="card-header">
                      <h4 className="heading mb-0">{barchartData.pair}</h4>
                      <ul className="box-controls pull-right">
                        <li>
                          <Link to={"#"} className="box-btn-fullscreen"></Link>
                        </li>
                      </ul>
                    </div>
                    <div style={{ padding: 0 }} className="card-body">
                      {/* <div id="coin-chart"></div> */}
                      {/* <Index5CoinChart
                        pair={barchartData.pair}
                        data={barchartData.data}
                      /> */}

                      <TradingViewWidget
                        symbol={getTradingViewSymbol(selectedCoin)}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-xxl-5 col-xl-5">
                  <CountdownToNextMinute />
                  {/* <RangeSlider initialPercent={prediction} /> */}
                  <GaugeChart parameter={prediction} />
                </div>
              </div>
            </div>

            {/* another aiTradeData but for wins and losses */}

            <div className="col-xl-12">
              {/* order tables */}
              <div className="card">
                <Tab.Container defaultActiveKey="Order">
                  <div className="card-header border-0 pb-2 flex-wrap">
                    <h4 className="heading">Trade History</h4>
                    <>
                      <Nav className="order nav nav-tabs">
                        <Nav.Link as="button" eventKey="Order" type="button">
                          Open Positions
                        </Nav.Link>
                        <Nav.Link as="button" eventKey="Trade" type="button">
                          Trade Histroy
                        </Nav.Link>
                        <Nav.Link
                          as="button"
                          eventKey="AccountBalance"
                          type="button"
                        >
                          Account Balance Histroy
                        </Nav.Link>
                      </Nav>
                    </>
                  </div>
                  <div className="card-body pt-0 pb-0">
                    <Tab.Content>
                      <Tab.Pane eventKey="Order">
                        <div className="table-responsive dataTabletrade ">
                          {tabeData.length <= 0 ? (
                            <div
                              id="status_wrapper"
                              className="dataTables_wrapper no-footer"
                            >
                              <p
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignContent: "center",
                                  justifyContent: "center",
                                  alignTtems: "center",
                                }}
                              >
                                {" "}
                                No Open Positions
                              </p>
                            </div>
                          ) : (
                            <div
                              id="status_wrapper"
                              className="dataTables_wrapper no-footer"
                            >
                              <table
                                id="example"
                                className="table display dataTable no-footer"
                                style={{ minWidth: "845px" }}
                              >
                                <thead>
                                  <tr>
                                    <th>Date</th>
                                    <th>Pair</th>
                                    <th>Side</th>
                                    <th>Size</th>
                                    <th>Entry Point</th>
                                    <th>PnL</th>
                                    <th>TP</th>
                                    <th className="text-end">SL</th>
                                    {/* <th className="text-end">Image</th> */}
                                  </tr>
                                </thead>
                                <tbody>
                                  {tabeData.map((item, index) => (
                                    <tr key={index}>
                                      <td>{item.date}</td>
                                      <td>{item.pair}</td>
                                      <td
                                        style={{
                                          color:
                                            item.side == "Short"
                                              ? "red"
                                              : item.side == "Long"
                                              ? "green"
                                              : "inherit",
                                        }}
                                      >
                                        {item.side}
                                      </td>
                                      <td>{item.size}</td>
                                      {/* <td>{item.price}</td> */}
                                      <td>{item.entry}</td>
                                      <td>
                                        {Number(item.pnl).toFixed(2) || 0}
                                      </td>
                                      <td>
                                        {Number(item.rPnl).toFixed(2) || 0}
                                      </td>
                                      <td className="text-end">
                                        {Number(item.sPnl).toFixed(2) || 0}
                                      </td>

                                      {/* <td className="text-end">
                                        <img
                                          src={
                                            item.image ||
                                            "https://picsum.photos/200/200"
                                          }
                                          alt="thumbnail"
                                          style={{
                                            width: "50px",
                                            cursor: "pointer",
                                          }}
                                          onClick={() =>
                                            handleShowImageModal(
                                              item.image ||
                                                "https://picsum.photos/200/300"
                                            )
                                          }
                                        />
                                      </td> */}
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                              <div className="d-sm-flex text-center justify-content-between align-items-center mt-3 mb-3">
                                <div className="dataTables_info">
                                  Showing {activePag.current * sort + 1} to{" "}
                                  {data.length > (activePag.current + 1) * sort
                                    ? (activePag.current + 1) * sort
                                    : data.length}{" "}
                                  of {data.length} entries
                                </div>
                                <div
                                  className="dataTables_paginate paging_simple_numbers mb-0"
                                  id="application-tbl1_paginate"
                                >
                                  <Link
                                    className="paginate_button previous "
                                    to="/"
                                    onClick={() =>
                                      activePag.current > 0 &&
                                      onClick(activePag.current - 1)
                                    }
                                  >
                                    <i className="fa fa-angle-double-left"></i>
                                  </Link>
                                  <span>
                                    {paggination.map((number, i) => (
                                      <Link
                                        key={i}
                                        to="/"
                                        className={`paginate_button  ${
                                          activePag.current === i
                                            ? "current"
                                            : ""
                                        } `}
                                        onClick={() => onClick(i)}
                                      >
                                        {number}
                                      </Link>
                                    ))}
                                  </span>

                                  <Link
                                    className="paginate_button next"
                                    to="/"
                                    onClick={() =>
                                      activePag.current + 1 <
                                        paggination.length &&
                                      onClick(activePag.current + 1)
                                    }
                                  >
                                    <i className="fa fa-angle-double-right"></i>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </Tab.Pane>

                      <Tab.Pane eventKey="Trade">
                        <TradeTab tabDataBlog={activityData} />
                      </Tab.Pane>
                      <Tab.Pane eventKey="AccountBalance">
                        <div
                          style={{
                            justifyContent: "center",
                            alignItems: "center",
                            marginTop: "20px",
                          }}
                          className="row"
                        >
                          {winAndLossData.map((item, ind) => (
                            <div
                              className="col-xl-4 col-lg-6 col-sm-6"
                              key={ind}
                            >
                              <div className={`card card-box ${item.bgcolor}`}>
                                <div className="card-header border-0 pb-0">
                                  <div className="chart-num-days">
                                    <p>{item.name}</p>
                                    <h2 className="count-num text-white">
                                      {item.price}
                                    </h2>
                                  </div>
                                  {item.id === 1 ? (
                                    <svg
                                      width="50"
                                      height="50"
                                      viewBox="0 0 137 137"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M92.9644 53.8221C92.9599 48.4197 88.5804 44.0417 83.1795 44.0357H53.822V63.6069H83.1795C88.5804 63.6024 92.9599 59.2229 92.9644 53.8221Z"
                                        fill="#FFF"
                                      />
                                      <path
                                        d="M53.822 92.9645H83.1795C88.5834 92.9645 92.9644 88.5835 92.9644 83.1796C92.9644 77.7743 88.5834 73.3933 83.1795 73.3933H53.822V92.9645Z"
                                        fill="#FFF"
                                      />
                                      <path
                                        d="M68.5001 9.15527e-05C30.6687 9.15527e-05 0.00012207 30.6687 0.00012207 68.5001C0.00012207 106.332 30.6687 137 68.5001 137C106.332 137 137 106.332 137 68.5001C136.957 30.6866 106.314 0.0433939 68.5001 9.15527e-05V9.15527e-05ZM102.751 83.1781C102.737 93.9828 93.9829 102.737 83.1797 102.749V107.643C83.1797 110.345 80.9877 112.536 78.2865 112.536C75.5838 112.536 73.3933 110.345 73.3933 107.643V102.749H63.6084V107.643C63.6084 110.345 61.4164 112.536 58.7153 112.536C56.0126 112.536 53.8221 110.345 53.8221 107.643V102.749H39.144C36.4414 102.749 34.2509 100.559 34.2509 97.8577C34.2509 95.155 36.4414 92.9645 39.144 92.9645H44.0357V44.0357H39.144C36.4414 44.0357 34.2509 41.8452 34.2509 39.1425C34.2509 36.4399 36.4414 34.2493 39.144 34.2493H53.8221V29.3577C53.8221 26.655 56.0126 24.4645 58.7153 24.4645C61.4179 24.4645 63.6084 26.655 63.6084 29.3577V34.2493H73.3933V29.3577C73.3933 26.655 75.5838 24.4645 78.2865 24.4645C80.9891 24.4645 83.1797 26.655 83.1797 29.3577V34.2493C93.9426 34.2045 102.705 42.8919 102.751 53.6548C102.775 59.3543 100.304 64.7791 95.9867 68.5001C100.263 72.1793 102.731 77.5354 102.751 83.1781V83.1781Z"
                                        fill="#FFF"
                                      />
                                    </svg>
                                  ) : item.id === 2 ? (
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="50px"
                                      height="50px"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        fill="rgb(255, 255, 255)"
                                        d="M21.000,42.000 C9.402,42.000 -0.001,32.598 -0.001,21.000 C-0.001,9.402 9.402,-0.000 21.000,-0.000 C32.592,0.013 41.987,9.408 42.000,21.000 C42.000,32.598 32.598,42.000 21.000,42.000 ZM28.171,14.437 C28.383,14.172 28.499,13.843 28.499,13.504 C28.500,12.675 27.829,12.001 26.999,12.000 L22.499,12.000 L22.499,7.500 C22.499,6.672 21.828,6.000 21.000,6.000 C20.171,6.000 19.500,6.671 19.500,7.500 L19.500,12.000 L15.000,12.000 C14.171,12.000 13.499,12.671 13.499,13.500 C13.499,14.328 14.171,15.000 15.000,15.000 L23.878,15.000 L13.827,27.562 C13.615,27.829 13.499,28.160 13.499,28.501 C13.499,29.329 14.171,30.000 15.000,30.000 L19.500,30.000 L19.500,34.500 C19.500,35.328 20.171,36.000 21.000,36.000 C21.828,36.000 22.499,35.328 22.499,34.500 L22.499,30.000 L26.999,30.000 C27.828,30.000 28.500,29.328 28.500,28.500 C28.500,27.672 27.828,27.000 26.999,27.000 L18.121,27.000 L28.171,14.437 Z"
                                      />
                                    </svg>
                                  ) : (
                                    ""
                                  )}
                                </div>
                                <div className="card-body p-0 custome-tooltip">
                                  {/* <div id="widgetChart3" className="chart-primary"></div> */}
                                  <WidgetChartIndex3
                                    title={item.name}
                                    data={item.data}
                                    xAxisData={item.xAxisData}
                                  />
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                        <AccountBalanceChart data={accountBalanceData} />
                      </Tab.Pane>
                    </Tab.Content>
                  </div>
                </Tab.Container>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* </div> */}

      <Modal show={showImageModal} onHide={() => setShowImageModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Image</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <img src={modalImageSrc} alt="Full Size" style={{ width: "100%" }} />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Home;
